import { RequestConfig } from '@/interface'

const PRIFIX = 'fpgj/apply/'
const YWDJH_PRIFIX = 'fpgj/apply/fpqs/'
const invoiceCollectionConfig: RequestConfig = {
  // 代扣代缴完税凭证列表-新增
  collectDkdjwspzlb: {
    url: `${PRIFIX}dkdjwspzlb`,
    method: 'post'
  },
  // 发票归集记录列表
  collectFpgjjllb: {
    url: `${PRIFIX}fpgjjllb`,
    method: 'post'
  },
  // 发票归集 申请
  collectFpgjsq: {
    url: `${PRIFIX}fpgjsq`,
    method: 'post'
  },
  // 发票明细列表-新增
  collectFpmxlb: {
    url: `${PRIFIX}fpmxlb`,
    method: 'post'
  },
  // 发票明细列表-导出
  fpmxlbDownload: {
    url: `${PRIFIX}fpmxlbDownload`,
    method: 'post'
  },
  // 海关缴款书列表-新增
  collectHgjkslb: {
    url: `${PRIFIX}hgjkslb`,
    method: 'post'
  },
  // 发票归集下载
  fpgjjlDownload: {
    url: `${PRIFIX}fpgjjlDownload`,
    method: 'post'
  },
  // 发票清单导入
  fpqdLead: {
    url: `${PRIFIX}import`,
    method: 'post'
  },
  fpqdLeadRecord: {
    url: `${PRIFIX}import-log/list`,
    method: 'post'
  },
  // 业务单据清单导入日志详情列表
  ywdjhDetails: {
    url: `${YWDJH_PRIFIX}details`,
    method: 'post'
  },
  // 业务单据清单导入签收
  ywdjhImport: {
    url: `${YWDJH_PRIFIX}import`,
    method: 'post'
  },
  // 业务单据清单导入(预导入)
  ywdjhPre: {
    url: `${YWDJH_PRIFIX}import/pre`,
    method: 'post'
  },
  // 业务单据清单导入(预导入删除)
  ywdjhDel: {
    url: `${YWDJH_PRIFIX}import/pre/del`,
    method: 'post'
  },
  // 业务单据清单导入(预导入明细删除)
  ywdjhDetailDel: {
    url: `${YWDJH_PRIFIX}import/pre/details/del`,
    method: 'post'
  },
  // 发票签收标记预导入状态查询
  ywdjhStatus: {
    url: `${YWDJH_PRIFIX}list/pre`,
    method: 'post'
  }
}
export default invoiceCollectionConfig
